// extracted by mini-css-extract-plugin
module.exports = {"samplesSlider":"SamplesSlider_samplesSlider__4CUs1","btnWrap":"SamplesSlider_btnWrap__a5H8z","moreBtn":"SamplesSlider_moreBtn__hrimv","ctaCard":"SamplesSlider_ctaCard__O_dRO"};